// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// ng serve --configuration=dev
// ng build --configuration=dev

export const environment = {
  production: false,
  companyName:"FLP",
  slogan:"Kurierdienst und Paketversand",
  gatewayApiUrl:"https://flpdev.parklabtechnologie.com",
  graphqlUrl:"https://flpdev-aggregator-service.parklabtechnologie.com/graphql",
  flpUrl:"https://flp-dev.parklab.app",
  leadShiftUrl:"https://leadshift-dev.parklab.app",
  countbookUrl:"https://lager-dev.parklab.app"
};

